import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
  Box 
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Bell } from "lucide-react";
import ProfileMenu from "../navProfile/ProfileMenu";
import DocsHelpLink from "../docs/DocsHelpLink";
import NotificationBadge from "../notifications/NotificationBadge";
import NotificationPanel from "../notifications/NotificationPanel";
import { togglePanel } from "../../features/notifications/notificationsSlice";
import { useNotificationPolling } from "../../hooks/useNotificationPolling";
import styles from "./Navbar.module.scss";

const NAVIGATION_LABELS = {
  viewNotifications: "View notifications",
};

const Navbar = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const notificationButtonRef = useRef(null);

  useNotificationPolling();

  const user = auth?.user;

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleViewNotifications = () => {
    dispatch(togglePanel());
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.main,
        height: 43,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left Section (Placeholder for Branding or Navigation) */}
      <Box sx={{ flexGrow: 1 }}>
        {/* You can place a logo or title here */}
      </Box>

      {/* Right Section (Icons & Profile) */}
      <Box 
       sx={{ 
        display: "flex", 
        alignItems: "center", 
        padding: "0px 10px"
       }}>
        <DocsHelpLink />

        <button
          ref={notificationButtonRef}
          type="button"
          className={styles.notificationButton}
          aria-label={NAVIGATION_LABELS.viewNotifications}
          onClick={handleViewNotifications}
        >
          <NotificationBadge count={unreadCount}>
            <Bell size={20} aria-hidden="true" />
          </NotificationBadge>
        </button>

        {/* Profile Menu */}
        <ProfileMenu 
          user={user}
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}
        />
      </Box>

      <NotificationPanel anchorEl={notificationButtonRef.current} />
    </Box>
  );
};

export default Navbar;
